import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getPreOrder} from 'api/requests';
import {IPreOrderRequest, IPreOrderResponse} from 'types';

export const usePreOrder = (params: IPreOrderRequest, options: UseQueryOptions<IPreOrderResponse[]>) => {
  return useQuery<IPreOrderResponse[]>({
    queryKey: ['preorder', params.slug],
    queryFn: async () => getPreOrder(params),
    ...options,
  });
};
